import InsightsTrendsData from './InsightsTrendsData'

export default InsightsTrendsData
